export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/hxtax.worker.d09db305.worker.js");
}
